import { MutableRefObject, useCallback, useEffect, useLayoutEffect, useState } from "react";

function useElementClientBoundingRect(
  elementRef: MutableRefObject<HTMLElement | null>
): ClientRect | null {
  const [clientRect, setClientRect] = useState<ClientRect | null>(null);

  const updateClientRect = useCallback(() => {
    const element = elementRef.current;
    if (!element) {
      return;
    }

    setClientRect(element.getBoundingClientRect());
  }, [elementRef]);

  useLayoutEffect(updateClientRect, []);

  useEffect(() => {
    window.addEventListener("resize", updateClientRect);

    return () => window.removeEventListener("resize", updateClientRect);
  }, [updateClientRect]);

  return clientRect;
}

export default useElementClientBoundingRect;
